export default {}



// WEBPACK FOOTER //
// ./src/store/modules/companies/mutations.js